import { createFilterConfig } from '@/Components/filterbar';
import { ZnglistsQuery } from '@/graphql/queries/Znglist.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { PostStatusEnum } from '@/graphql/types';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
export const ZnglistFilterConfig = createFilterConfig({
  routeId: '/dash/znglists/',
  options: {
    restoreOnMount: true
  }
}, {
  search: true,
  visibility: true,
  author: true,
  znglistTemplate: true,
  date: true,
  order: true
});
export const Route = createFileRoute('/dash/znglists/')({
  validateSearch: ZnglistFilterConfig.filterSearchValidator,
  loader: () => {
    return loadQuery(RelayEnvironment, ZnglistsQuery, {
      first: 24,
      where: {
        stati: [PostStatusEnum.Publish, PostStatusEnum.Hidden, PostStatusEnum.Draft]
      }
    });
  }
});